import forEach from 'lodash/forEach'

import { createReducer } from '../../utilities';

import { scope } from '../../../actions/app/mpt/clubs';
import {
    GET_MPT_CLUBS, GET_MPT_CLUBS_SUCCESS, GET_MPT_CLUBS_ERROR,
    EDIT_MPT_CLUB, EDIT_MPT_CLUB_SUCCESS, EDIT_MPT_CLUB_ERROR,
    POST_MPT_CLUB, POST_MPT_CLUB_SUCCESS, POST_MPT_CLUB_ERROR,
} from '../../../actions/entities/mpt/clubs';

const initialClubsState = {
    list: null,
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { response, receivedAt, success } = action;
    return {
        ...state,
        list: response.data.clubs,
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false
        }
    }
}

function fail(state, action) {
    const { error } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            success: false,
            error
        }
    };
}

function successEditMptClub(state, action) {
    const { response } = action;
    let freshList = state.list;
    forEach(state.list, (club, i) => {
        if (club.id === response.data.id) {
            freshList[i] = response.data;
        }
    });
    return {
        ...state,
        list: [
            ...freshList,
        ],
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            success: true,
            error: false
        }
    }
}

function successPostMptClub(state, action) {
    const { response } = action;
    let freshList = state.list;
    freshList.push(response.data);
    return {
        ...state,
        list: [
            ...freshList,
        ],
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            success: true,
            error: false
        }
    }
}

export default createReducer(initialClubsState, {
    [GET_MPT_CLUBS]: request,
    [GET_MPT_CLUBS_SUCCESS]: success,
    [GET_MPT_CLUBS_ERROR]: fail,

    [EDIT_MPT_CLUB]: request,
    [EDIT_MPT_CLUB_SUCCESS]: successEditMptClub,
    [EDIT_MPT_CLUB_ERROR]: fail,

    [POST_MPT_CLUB]: request,
    [POST_MPT_CLUB_SUCCESS]: successPostMptClub,
    [POST_MPT_CLUB_ERROR]: fail,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/mpt/clubs.js